import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'




const toggleNav = true
const navMobile = true


const order = 'sayed'




export const toggleElement= create()(
  immer((set) => ({

    toggleNav:toggleNav,
    navMobile:navMobile,
      setUser: (user) =>
      set((state) => {
          state.user = user
      }),
      setToggleNav: (toggleNav) =>
      set((state) => {
          state.toggleNav = toggleNav
      }),
      setNavMobile: (navMobile) =>
      set((state) => {
          state.navMobile = navMobile
      }),
  })),
)


export const dataDashboard = create()(
  immer((set) => ({

    order : order ,

      setOrder: (order) =>
      set((state) => {
          state.order = order
      }),

  })),
)